// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-blog-js": () => import("./../../../src/pages/blog.js" /* webpackChunkName: "component---src-pages-blog-js" */),
  "component---src-pages-contact-js": () => import("./../../../src/pages/contact.js" /* webpackChunkName: "component---src-pages-contact-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-project-js": () => import("./../../../src/pages/project.js" /* webpackChunkName: "component---src-pages-project-js" */),
  "component---src-templates-blog-temp-js": () => import("./../../../src/Templates/BlogTemp.js" /* webpackChunkName: "component---src-templates-blog-temp-js" */),
  "component---src-templates-github-repo-temp-js": () => import("./../../../src/Templates/GithubRepoTemp.js" /* webpackChunkName: "component---src-templates-github-repo-temp-js" */)
}

